import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { OrderResponse } from '@models/order/orderLog';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import OrderItem from './OrderItem';

interface Props {
    orderLog: OrderResponse;
}

function OrderItems({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const { orderItems } = orderLog;
    return (
        <Card as='section'>
            <Text size='title' fontWeight='bold'>{t('items.title')}</Text>
            <Column fullWidth spacing={4}>
                {orderItems.map((orderItem, index) => (
                    <Fragment key={orderItem.itemId}>
                        {index > 0 && <Divider/>}
                        <OrderItem orderItem={orderItem}/>
                    </Fragment>
                ))}
            </Column>
        </Card>
    );
}

const Card = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    margin: var(--spacing-6) var(--spacing-4) 0;
    padding: var(--spacing-4);
    width: calc(100% - var(--spacing-8));
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: var(--color-background-raised);
`;

export default OrderItems;
